module.exports = __webpack_public_path__ + "static/media/import_02.a8fce3d4.svg";